/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */
import {Type} from "@qwoach/class-transformer-wrapper";
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseSmartFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/BaseSmartFormElement";
import {formTriggerValidator} from "@/utils/helpers";
import AddressItem from "@shared/Profile/AddressItem";

export default class FormElementAddress extends BaseSmartFormElement {

	@Type(() => AddressItem)
	answer: AddressItem = new AddressItem()

	constructor(title, options = {}) {
		super(FormElementType.ADDRESS, title, {required: true, ...options});
	}

	getAnswerFormatted(){
		return this.answer.toString()
	}

	resetElement() {
		super.resetElement();
		this.title = "Address"
		this.answer = new AddressItem()
		this.isRequired = true
		this.showRequiredSwitch = false
		this.placeholder = "Address Question Text"
		// this.disableEditing = true
		// this.specialQuestionDescription = "address"
	}


	getSpecialQuestionDescription(){
		return "address"
	}

	getSmartFiledPropertyName(){
		return "primaryAddress"
	}


	getValidateRules(){
		return formTriggerValidator(async (value) => {
			let error

			let hasStreet = !!this.answer.street
			let hasCity = !!this.answer.city
			let hasZip = !!this.answer.zip
			let hasCountry = !!this.answer.country

			if(this.isRequired && !(hasStreet || hasCity || hasZip || hasCountry)){
				error = "Please fill in at least one field"
			}

			return error
		})
	}

}
